import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { axios } from "@features/config";
import { RemainingVoteWeight } from "@dto/delegations";

const useRemainingVoteWeight = () => {
  const { roundtableId, projectId } = useParams();
  const conversationId = projectId ?? roundtableId;
  
  const { data, ...rest } = useQuery(
    ['remaining-vote-weight', conversationId],
    () => axios.get(`round-tables/${conversationId}/current-vote-weight`),
    {
      enabled: !!conversationId,
    }
  )

  return {
    data: data?.data?.data as RemainingVoteWeight[],
    ...rest,
  }
}

export default useRemainingVoteWeight
